<template>
  <Breadcrumbs
      title="Dealer Sales Update"
      :breadcrumbs="[
      { label: 'Reports', path: '' },
      { label: 'Dealer Sales Report', path: '/daily-sales-report' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <salesReport />
    </div>
  </div>
</template>

<script>
import salesReport from './salesReportTable.vue';
export default {
  name: 'indexList',
  components: {
    salesReport
  },
}
</script>
